import { Helmet } from 'react-helmet-async'

import { Box, Columns, LoadingModule } from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useCurrentUser from '@hooks/useCurrentUser'
import useCustomDeadlines from '@hooks/useCustomDeadlines'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import generateDeadlineTabItems from '../../../../components/utils/generateDeadlineTabItems'
import CustomDeadLinesBlankState from '../CustomDeadlinesBlankState'
import Deadlines from '../Deadlines'

const PageContent = () => {
  const { agencyIdParam, selectedAgency, selectedAgencyId } = useAgencySelector()

  const { isAgent, isEbuAdmin } = useCurrentUser()

  const customDeadlinesPayload = useCustomDeadlines({
    filters: {
      owner_id: isAgent || isEbuAdmin ? undefined : selectedAgencyId,
      owner_type: 'Agency',
    },
    performHttpRequests: !!agencyIdParam,
  })

  const {
    filteredCustomDeadlines,
    hasFilteredCustomDeadlines,
    loading,
  } = customDeadlinesPayload

  return (
    <>
      <Helmet>
        <title>Deadlines | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="custom-deadlines"
        nestedNavigation
        tabBarItems={generateDeadlineTabItems(agencyIdParam!)}
        title="Deadlines"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.customDeadlines.banner" />

            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredCustomDeadlines && <CustomDeadLinesBlankState />}

            {!loading && hasFilteredCustomDeadlines && (
              <Deadlines
                customDeadlines={filteredCustomDeadlines}
                selectedAgency={selectedAgency}
              />
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyManager.customDeadlines.sidebar" />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
